import Vue from 'vue'

export default function recalcStudentOrder({ data }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/orders/students/" + data.student_id + "/recalculate/" + data.id
    return Vue.http
        .post(url, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response)
}